module.exports = __webpack_public_path__ + "img/03@2x.5ee40079.png";